export default __webpack_public_path__ + "static/media/FINANCE-02.44ebc748.png";